import React, { createRef, useImperativeHandle, useState } from 'react';

export interface ToastHandle {
  show: (msg: string, timer?: number) => void;
  success: (msg: string) => void;
}

export const toastRef = createRef<ToastHandle>();

const ToastContainer = React.forwardRef<ToastHandle>(({ }, ref) => {
  const [visible, show] = useState(false);
  const [msg, setMsg] = useState('');
  const [type, setType] = useState('WARNING');

  useImperativeHandle(ref, () => ({
    show: (msg: string, timer = 3000) => {
      show(true);
      setMsg(msg);
      setType('WARNING');
      setTimeout(function () {
        show(false);
      }, timer);
    },
    success: (msg: string) => {
      show(true);
      setMsg(msg);
      setType('SUCCESS');
      setTimeout(function () {
        show(false);
      }, 3000);
    },
  }));

  return (
    <div id="snackbar" className={`${visible ? 'show' : ''} ${type}`}>{msg}</div>
  )
})

export default ToastContainer;
